import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateAfterInvoiceChange } from "../../../utils/invoiceQueryInvalidation";
import { setInvoiceTip } from "../actions/setInvoiceTip";

export const useSetInvoiceTip = (invoiceUid?: string) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: setInvoiceTip,
    onSuccess: () => {
      if (invoiceUid) {
        invalidateAfterInvoiceChange(queryClient, { invoiceUid });
      }
    },
  });

  return {
    setInvoiceTip: mutation.mutateAsync,
    isSavingTip: mutation.isPending,
  };
};
